module.exports = __webpack_public_path__ + "static/media/HeroVideo.cfc902ae.mp4";